import { render, staticRenderFns } from "./templateAdd.vue?vue&type=template&id=30eb4415&scoped=true&"
import script from "./templateAdd.vue?vue&type=script&lang=js&"
export * from "./templateAdd.vue?vue&type=script&lang=js&"
import style0 from "./templateAdd.vue?vue&type=style&index=0&id=30eb4415&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb4415",
  null
  
)

export default component.exports